import { apolloClient } from '~/apollo-client';
import {
  Flex_UpdateCustomerSnapshotMutation,
  Flex_UpdateCustomerSnapshotMutationVariables,
  UpdateCustomerSnapshotInput,
} from '~/typings/graphql';
import { UPDATE_CUSTOMER_SNAPSHOT } from './update-customer-snapshot.queries';

export const updateCustomerSnapshot = async (
  utilityAccountId: number,
  input: UpdateCustomerSnapshotInput,
) => {
  await apolloClient.mutate<
    Flex_UpdateCustomerSnapshotMutation,
    Flex_UpdateCustomerSnapshotMutationVariables
  >({
    mutation: UPDATE_CUSTOMER_SNAPSHOT,
    variables: {
      utilityAccountId,
      input,
    },
  });
};
